export default __webpack_public_path__ + "static/background_city-524c97e1cbdd8d8ad6ae888044e85dd6.svg";